import styled from "styled-components";
import { setFontVariant } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StepsCompletionContainer = styled(FlexColumn)`
    gap: 8px;
    padding: 0 8px 8px 8px;
`;

export const CompletionStepContainer = styled(FlexRow)`
    box-shadow: 0 3px 6px rgba(14, 30, 62, 0.08);
    min-height: 164px;
    justify-content: space-between;
    border-radius: 6px;
    background-color: ${colorsPalettes.carbon[0]};
`;

export const ContentContainer = styled(FlexColumn)`
    justify-content: space-between;
    margin: 18px 24px 24px 24px;
`;

export const HeaderContentContainer = styled(FlexColumn)``;

export const Title = styled.span`
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])};
    margin-bottom: 2px;
`;

export const Description = styled.p`
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
    margin-bottom: 24px;
`;

export const ButtonsContainer = styled(FlexRow)`
    gap: 8px;
`;

export const NewSearchButton = styled((props) => (
    <Button
        height="36px"
        {...props}
    />
))`
    ${setFontVariant("button")};
`;

export const Image = styled.img`
    border-radius: 6px;
    animation: fade 0.5s;
`;
